import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { CampaignManager } from "@/components/app/campaign-manager";

const description =
  "Invite people to volunteer with T1D Warriors and track who moves from contact to signed up volunteer.";

export const Route = createFileRoute("/_authenticated/t1dwpanel/campaign")({
  validateSearch: (search: Record<string, unknown>): { tab?: string } =>
    typeof search.tab === "string" ? { tab: search.tab } : {},
  head: () => ({
    meta: [
      { title: "Recruit volunteers | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Recruit volunteers | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CampaignPage,
});

function CampaignPage() {
  return (
    <AppShell title="Recruit volunteers" eyebrow="Admin">
      <CampaignManager />
    </AppShell>
  );
}
